import React, { useState } from 'react';
import { safeMutate } from '../../../../utils/GeneralUtils';
import { ChrSelectTemplates } from '../../../specific/Group/templates/Filters/SelectAndDatePickerTemplate';
import ChrSelect from '../Basic/ChrSelect';
import { getUId, propagateData } from '../utils';
import ChrDatePicker from './ChrDatePicker';
import ChrTooltip from '../Basic/ChrTooltip';
import { dateRangePickerFields } from '../constants';
import { getCommonDateRangeFields } from '../../Utils/commonUtils';
/*

props = {
  data:{
    presets: [
      {
        label: <>,
        value: <>,
        from: <mm/dd/yyyy>,
        to: <mm/dd/yyyy>,
        canEdit: < true || false >,
        selected: < true || false >,
        tooltipContent: <>
      }
    ],
    from: {
      data: {
        value: <>,
        placeholder: <>,
        defaultValue: <>,
        className: <>,
        disabled: <>,
        locale: <>
      }
    },
    to: {
      data: {
        value: <>,
        placeholder: <>,
        defaultValue: <>,
        className: <>,
        disabled: <>,
        locale: <>
      }
    },
    uId: <uniqueIdentifier>
  }
  onChange: <handler>
}

*/

const ChrDateRangePicker = (props) => {
  const formData = props.data;
  const myUId = getUId(props);
  const fromDatePickerUId = "from";
  const toDatePickerUId = "to";
  const presetsData = formData.presets || [];
  const { presetOptions = {} } = props;

  const getPresets = (presetsData) => {
    if (presetsData && presetsData.length) {
      return [true, presetsData];
    } else {
      return [false, []];
    }
  }

  const [canRenderPresets, presets] = getPresets(presetsData);
  const selectedPreset = presetsData.find(preset => preset.selected) || { canEdit: true };
  const tooltipContent = selectedPreset.tooltipContent;
  const { allowedFields } = getCommonDateRangeFields(null, selectedPreset.allowedFields);

  const presetsHandler = (_event, _childUId, childData) => {
    const newFormData = safeMutate(formData, draftFormData => {
      draftFormData[fromDatePickerUId].data.value = childData.from || draftFormData[fromDatePickerUId].data.value;
      draftFormData[toDatePickerUId].data.value = childData.to || draftFormData[toDatePickerUId].data.value;
      draftFormData.presets.forEach((preset) => preset.selected = (preset.value === childData.value));
    });
    propagateData("onChange", myUId, newFormData, props);
  }

  const onChangeHandler = (event, childUId, childData) => {
    const newFormData = safeMutate(formData, draftFormData => {
      draftFormData[childUId].data.value = childData.value;
    });
    propagateData(event, myUId, newFormData, props);
  };

  const getMinMaxDates = (formData) => {
    /*
      Note that we should not be able to choose a 'from' date past the 'to' date
      or choose a 'to' date earlier than the 'from' date.
      This method compares the values selected in 'from' date picker and 'to' date picker
      and the minDate and maxDate passed for each date picker
      and return the minDate and maxDate applicable for each datepicker.
    */
    let fromMinMaxDate = {};
    let toMinMaxDate = {};
    const fromDate = formData[fromDatePickerUId].data.value;
    const toMinDate = formData[toDatePickerUId].data.minDate;

    if (fromDate && toMinDate) {
      const fromDateObj = new Date(fromDate).getTime();
      const toMinDateObj = new Date(toMinDate).getTime();
      toMinMaxDate.minDate = (fromDateObj > toMinDateObj) ? fromDate : toMinDate;
    } else if (fromDate) {
      toMinMaxDate.minDate = fromDate;
    }
    toMinMaxDate.maxDate = formData[toDatePickerUId].data.maxDate;

    const toDate = formData[toDatePickerUId].data.value;
    const fromMaxDate = formData[fromDatePickerUId].data.maxDate;

    if (toDate && fromMaxDate) {
      const toDateObj = new Date(toDate).getTime();
      const fromMaxDateObj = new Date(fromMaxDate).getTime();
      fromMinMaxDate.maxDate = (toDateObj < fromMaxDateObj) ? toDate : fromMaxDate;
    } else if (toDate) {
      fromMinMaxDate.maxDate = toDate;
    }
    fromMinMaxDate.minDate = formData[fromDatePickerUId].data.minDate;

    return [fromMinMaxDate, toMinMaxDate];
  }

  const [fromDatePickerMinMaxDate, toDatePickerMinMaxDate] = getMinMaxDates(formData);

  const fromDatePickerFormData = {
    ...formData[fromDatePickerUId].data,
    ...fromDatePickerMinMaxDate,
    disabled: !selectedPreset.canEdit
  };
  const toDatePickerFormData = {
    ...formData[toDatePickerUId].data,
    ...toDatePickerMinMaxDate,
    disabled: !selectedPreset.canEdit
  };

  return (
    <React.Fragment>
      <div className='d-flex flex-column'>
        {
          canRenderPresets &&
          <ChrSelect
            selectType={"Select"}
            reactSelectOptions={{
              ...ChrSelectTemplates.OverflowTemplate,
              isMulti: false,
              options: presets,
              value: selectedPreset,
              className: presetOptions.className,
              srLabel: props.srLabel
            }}
            onChange={presetsHandler}
          />
        }
        {tooltipContent && <ChrTooltip showTextExplicitly={true} content={tooltipContent} className="custom-width-17 break-word-all" />}
        { allowedFields.includes(dateRangePickerFields.FROM) && <ChrDatePicker uId={fromDatePickerUId} data={fromDatePickerFormData} onChange={onChangeHandler} formControlClass="cjs-date-range-picker-from-date" /> }
        { allowedFields.includes(dateRangePickerFields.TO) && <ChrDatePicker uId={toDatePickerUId} data={toDatePickerFormData} onChange={onChangeHandler} formControlClass="cjs-date-range-picker-to-date" /> }
      </div>
    </React.Fragment>
  );
};

export default ChrDateRangePicker;
